import React from "react";
import ImportantInformation from "../secure/Dashboard/ImportantInformation/ImportantInformation";
import track from "react-tracking";
export default track({ page: "Disclaimers" }, { dispatchOnMount: true })(() => (<div className="wrapper">
		<ImportantInformation disclaimers={[]} disclaimerIdMap={{}}/>
	</div>));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Disclaimers.tsx